module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_costumes-062b886cfc9550dbf7355c49ced09049.jpg";